<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
      @checkbox-change="(rows) => (checkedRows = rows)"
    >
      <div slot="header" class="d-flex">
        <PageHeader
          ref="header"
          style="width: 100%;min-width: 250px; max-width: 600px;"
          @query="getData"
          @reset="resetPage"
        />
        <div class="vxe-button--opts">
          <b-button
            v-if="allow('A')"
            size="sm"
            variant="outline-success"
            @click="addCustomerVisible = true"
          >
            {{ $l('btn_batchAddCustomer') || '批量新增客户' }}
          </b-button>
          <b-button
            v-if="allow('A')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="addUserVisible = true"
          >
            {{ $l('btn_batchAddUser') || '批量新增人员' }}
          </b-button>

          <el-badge
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              :disabled="!checkedRowCount"
              @click="changeUser()"
            >
              {{ $l('btn_batchChangeUser') || '批量变更人员' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>
          <el-badge
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              :disabled="!checkedRowCount"
              @click="removeUser()"
            >
              {{ $l('btn_batchRemoveUser') || '批量移除人员' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>
        </div>
      </div>
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <EditForm
      :visible.sync="editFormOpts.visible"
      :type="editFormOpts.type"
      :custBizTeamSetCode="editFormOpts.custBizTeamSetCode"
      @reload="editReload"
    />

    <AddCustomer :visible.sync="addCustomerVisible" @reload="editReload" />

    <AddUser :visible.sync="addUserVisible" @reload="editReload" />

    <ChangeUser
      :visible.sync="changeUserOpts.visible"
      :listCustBizTeamSetCode="changeUserOpts.listCustBizTeamSetCode"
      @reload="editReload"
    />
  </div>
</template>

<script>
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import PageMain from './main.vue'
import PageHeader from './header.vue'
import EditForm from '../edit-form/index.vue'
import AddCustomer from '../add-customer'
import AddUser from '../add-user'
import ChangeUser from '../change-user'
export default {
  components: {
    PageMain,
    PageHeader,
    EditForm,
    AddCustomer,
    AddUser,
    ChangeUser,
  },
  mixins: [BaseTable, EditLoading],
  data() {
    return {
      usePage: true,
      checkedRows: [],
      editFormOpts: { visible: false, type: '', custBizTeamSetCode: '' },
      addCustomerVisible: false,
      addUserVisible: false,
      changeUserOpts: { visible: false, listCustBizTeamSetCode: [] },
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .masterCustomerBizTeamSetListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    editReload() {
      this.reload()
      this.clearCheckboxRow()
    },
    clearCheckboxRow() {
      this.$refs.main.clearCheckboxRow()
    },
    changeUser() {
      if (!this.checkedRowCount) return

      const listCustBizTeamSetCode = this.checkedRows.map(
        (row) => row.custBizTeamSetCode
      )
      this.changeUserOpts = { visible: true, listCustBizTeamSetCode }
    },
    async removeUser() {
      if (!this.checkedRowCount) return

      const confirm = await this.$confirm(
        this.$l('tips_removeUser') || '是否确认批量移除人员？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      const listCustBizTeamSetCode = this.checkedRows.map(
        (row) => row.custBizTeamSetCode
      )

      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerBizTeamSetRemoveUserApi({ listCustBizTeamSetCode })
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_remove_no') || '移除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_remove_ok') || '移除成功！',
        type: 'success',
      })
      this.editReload()
    },
    openEditFormDialog({ type, row: { custBizTeamSetCode } }) {
      this.editFormOpts = { visible: true, type, custBizTeamSetCode }
    },
  },
}
</script>
<style lang="scss" scoped>
.vxe-button--opts {
  margin: 0 12px;
  min-width: max-content;
}
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
